// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminProductDocuments = (client) => ({
    /**
     * `POST /admin/product-documents/:id/attach`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminBulkAttachProductDocument
     * @source packages/medusa-plugin-product-documents/src/api/admin/product-documents/[id]/attach/route.ts
     */
    attach: (id, body, query, headers) => client.fetch(buildPath("/admin/product-documents/:id/attach", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/product-documents`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminCreateProductDocument
     * @source packages/medusa-plugin-product-documents/src/api/admin/product-documents/route.ts
     */
    create: (body, query, headers) => client.fetch("/admin/product-documents", { method: "POST", body, query, headers }),
    /**
     * `DELETE /admin/product-documents/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminDeleteProductDocument
     * @source packages/medusa-plugin-product-documents/src/api/admin/product-documents/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/admin/product-documents/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /admin/product-documents`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListProductDocuments
     * @source packages/medusa-plugin-product-documents/src/api/admin/product-documents/route.ts
     */
    list: (query, headers) => client.fetch("/admin/product-documents", { method: "GET", query, headers }),
    /**
     * `GET /admin/product-documents/:id/associations`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetProductDocumentAssociations
     * @source packages/medusa-plugin-product-documents/src/api/admin/product-documents/[id]/associations/route.ts
     */
    listAssociations: (id, query, headers) => client.fetch(buildPath("/admin/product-documents/:id/associations", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/product-documents/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetProductDocument
     * @source packages/medusa-plugin-product-documents/src/api/admin/product-documents/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/admin/product-documents/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/product-documents/:id/signed-url`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetProductDocumentSignedUrl
     * @source packages/medusa-plugin-product-documents/src/api/admin/product-documents/[id]/signed-url/route.ts
     */
    retrieveSignedUrl: (id, query, headers) => client.fetch(buildPath("/admin/product-documents/:id/signed-url", [id]), { method: "GET", query, headers }),
    /**
     * `PUT /admin/product-documents/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminUpdateProductDocument
     * @source packages/medusa-plugin-product-documents/src/api/admin/product-documents/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/admin/product-documents/:id", [id]), { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=product-documents.js.map